"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var CartDrawer = /** @class */ (function (_super) {
    __extends(CartDrawer, _super);
    function CartDrawer(props) {
        var _this = _super.call(this, props) || this;
        _this.buildItems = function (cart) {
            var _a;
            var hasCartItems = (_a = cart.items) === null || _a === void 0 ? void 0 : _a.length;
            if (!hasCartItems) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(Snippets.Heading, { size: "h4", tag: "p", className: "font-medium text-center mt-1-7" }, "Your bag is empty."),
                    React.createElement(Snippets.Button, { onClick: function () { return _this.toggleCartDrawer(); }, style: "tertiary", className: "block mt-1-7 m-auto" }, "Continue Shopping")));
            }
            // BUG: placeholder logic never getting executed. what's the function of it?
            return (React.createElement("div", { className: "px-1-6 md:px-0 bg-arctic" }, hasCartItems
                ? cart.items.map(function (lineitem) { return (React.createElement(Snippets.CartItem, __assign({}, _this.props, { key: lineitem.key, lineitem: lineitem, quantity: lineitem.quantity, drawer: true }))); })
                : _this.buildPlaceholders(cart.item_count)));
        };
        _this.buildPlaceholders = function (limit) {
            var placeholders = [];
            for (var i = 0; i < limit; i++) {
                placeholders.push(React.createElement("div", { key: i, className: "flex flex-no-wrap py-1-5 md:py-2-3 border-b border-secondary" },
                    React.createElement("div", { className: "w-1/4" },
                        React.createElement("div", { className: "ratio-2:3 content-placeholder" })),
                    React.createElement("div", { className: "w-3/4 flex flex-col justify-between pl-2" },
                        React.createElement("div", { className: "flex items-start justify-between" },
                            React.createElement("div", { className: "w-3/4 pr-1" },
                                React.createElement("p", { className: "content-placeholder medium py-1" }),
                                React.createElement("p", { className: "content-placeholder large py-0-7 mt-1" })),
                            React.createElement("div", { className: "w-1/4 text-right" },
                                React.createElement("div", { className: "content-placeholder w-5 h-5 inline-block" }))),
                        React.createElement("div", { className: "flex items-center justify-between mt-2-5" },
                            React.createElement("div", { className: "w-1/2" },
                                React.createElement("div", { className: "content-placeholder large py-1-5" })),
                            React.createElement("div", { className: "w-1/2 pl-2 text-right" },
                                React.createElement("div", { className: "content-placeholder inline-block small py-1-5" }))))));
            }
            return placeholders;
        };
        _this.toggleCartDrawer = function () {
            _this.context.update({ cartOpen: false });
        };
        _this.state = {
            prevCart: null,
            itemAdded: false
        };
        return _this;
    }
    CartDrawer.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("/cart.js")];
                    case 1:
                        cart = _a.sent();
                        cart.json().then(function (data) {
                            return _this.setState({
                                prevCart: data
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CartDrawer.prototype.componentDidUpdate = function () {
        var _a = this.context.state, cart = _a.cart, cartOpen = _a.cartOpen;
        var prevCart = this.state.prevCart;
        var cartItems = cart && cart.items ? cart.items.map(function (item) { return item.key; }) : null;
        var prevCartItems = prevCart && prevCart.items ? prevCart.items.map(function (item) { return item.key; }) : null;
        cart && prevCart && cart.item_count != prevCart.item_count
            ? (this.setState({
                prevCart: cart,
                itemAdded: cartItems.length > prevCartItems.length || this.context.state.message == "CART_ITEM_ADDED_SUCCESS"
            }),
                !cartOpen && this.props.data.template.name != "cart"
                    ? this.context.update({
                        cartOpen: true
                    })
                    : null)
            : null;
    };
    CartDrawer.prototype.render = function () {
        var _this = this;
        var settings = this.props.data.section.cart.settings;
        var _a = this.context.state, cart = _a.cart, cartOpen = _a.cartOpen;
        var viewWidth = window.outerWidth;
        var headerHeight = document.querySelector(".sticky-inner-wrapper") ? document.querySelector(".sticky-inner-wrapper").clientHeight : 0;
        var notificationHeight = document.querySelector("#notification") ? document.querySelector("#notification").clientHeight : 0;
        var marginRight = viewWidth < 767 ? 0 : viewWidth > 1220 ? (viewWidth - 1220) / 2 - 22 : 22;
        var marginTop = headerHeight + (headerHeight > 70 ? notificationHeight : 0);
        var CartItems = function () { return (cart ? _this.buildItems(cart) : null); };
        return (cart && (React.createElement("section", { className: "fixed pin z-50 transition-fast " + (cartOpen ? "transition visible translate-x:0" : "transition-fast invisible pointer-events-none") },
            React.createElement("div", { className: "fixed pin bg-smoke transition cursor-pointer " + (cartOpen ? "visible opacity-100 pointer-events-auto" : "invisible opacity-0 pointer-events-none"), onClick: function () { return _this.toggleCartDrawer(); } }),
            React.createElement("div", { className: "rounded fixed flex flex-col bg-arctic text-midnight pin-y pin-r w-full md:w-39-2 max-w-full md:max-h-42 " + (cartOpen
                    ? "transition visible translate-y:0 pointer-events-auto transition-delay-25"
                    : "transition-fast invisible translate-y:100 pointer-events-none transition-delay-0"), style: { marginRight: marginRight, marginTop: marginTop } },
                React.createElement("div", { className: "arrow-t arrow-t-r w-full" }, this.state.itemAdded && (React.createElement("div", { className: "flex items-center justify-between p-1-6 select-none" },
                    React.createElement("div", { className: "" }),
                    React.createElement("div", { className: "flex-1 text-center flex felx-row items-center" },
                        React.createElement(Snippets.Svg, { name: "green-rounded-checkbox", width: 22 }),
                        React.createElement(Snippets.Heading, { size: "h1", tag: "p", className: "ml-0-8 mt-0-2 text-xmd font-semibold leading-none" }, "Added to your cart")),
                    React.createElement("div", { className: "text-right" },
                        React.createElement("button", { onClick: function () { return _this.toggleCartDrawer(); }, className: "block cursor-pointer transition-fast hover:text-charcoal focus:outline-none" },
                            React.createElement(Snippets.Svg, { name: "cross", width: 12 })))))),
                React.createElement("div", { className: "w-full flex-1 overflow-y-scroll" + (cart.items && cart.items.length >= 0 ? "" : " flex flex-col items-center justify-center") },
                    React.createElement(CartItems, null)),
                React.createElement("div", { className: "w-full bg-navy" },
                    settings.shipping && cart.items && cart.items.length >= 0 ? (React.createElement("div", { className: "p-1 text-md font-semibold text-arctic bg-water-blue text-center" }, cart.total_price > settings.shipping * 100 ? (React.createElement("p", { className: "font-medium text-xs" },
                        "Free shipping for orders over",
                        " ",
                        next_components_1.ShopifyNext.Utils.formatMoney(settings.shipping * 100, this.props.data.shop.money_format))) : (React.createElement("p", { className: "font-medium text-xs" },
                        "Spend ",
                        next_components_1.ShopifyNext.Utils.formatMoney(settings.shipping * 100 - cart.total_price, this.props.data.shop.money_format),
                        " ",
                        "more to be eligible for free shipping!")))) : null,
                    React.createElement("div", { className: "flex items-center text-arctic justify-between w-full py-2-4 px-2-8" },
                        React.createElement("p", { className: "text-md font-medium tracking-wide" }, "Product Total"),
                        React.createElement("p", { className: "text-xmd font-medium text-right tracking-normal" }, cart ? next_components_1.ShopifyNext.Utils.formatMoney(cart.total_price, "${{amount}}") : "$0.00")),
                    React.createElement("div", { className: "px-2-8 pb-2-8" },
                        React.createElement(Snippets.Button, { href: "/cart", style: "tertiary", disabled: !(cart.items && cart.items.length >= 0), className: "flex items-center justify-center w-full h-4-8 rounded", reverse: true }, "Checkout")))))));
    };
    return CartDrawer;
}(React.PureComponent));
exports.CartDrawer = CartDrawer;
CartDrawer.contextType = next_components_1.ShopifyNext.Context;
